// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    zendeskGet201893608 (params?: {}): Promise<Dict>;
    zendeskGet360000292886 (params?: {}): Promise<Dict>;
    publicGetTime (params?: {}): Promise<Dict>;
    publicGetSystemStatus (params?: {}): Promise<Dict>;
    publicGetAssets (params?: {}): Promise<Dict>;
    publicGetAssetPairs (params?: {}): Promise<Dict>;
    publicGetTicker (params?: {}): Promise<Dict>;
    publicGetOHLC (params?: {}): Promise<Dict>;
    publicGetDepth (params?: {}): Promise<Dict>;
    publicGetGroupedBook (params?: {}): Promise<Dict>;
    publicGetTrades (params?: {}): Promise<Dict>;
    publicGetSpread (params?: {}): Promise<Dict>;
    publicGetPreTrade (params?: {}): Promise<Dict>;
    publicGetPostTrade (params?: {}): Promise<Dict>;
    privatePostLevel3 (params?: {}): Promise<Dict>;
    privatePostBalance (params?: {}): Promise<Dict>;
    privatePostBalanceEx (params?: {}): Promise<Dict>;
    privatePostCreditLines (params?: {}): Promise<Dict>;
    privatePostTradeBalance (params?: {}): Promise<Dict>;
    privatePostOpenOrders (params?: {}): Promise<Dict>;
    privatePostClosedOrders (params?: {}): Promise<Dict>;
    privatePostQueryOrders (params?: {}): Promise<Dict>;
    privatePostOrderAmends (params?: {}): Promise<Dict>;
    privatePostTradesHistory (params?: {}): Promise<Dict>;
    privatePostQueryTrades (params?: {}): Promise<Dict>;
    privatePostOpenPositions (params?: {}): Promise<Dict>;
    privatePostLedgers (params?: {}): Promise<Dict>;
    privatePostQueryLedgers (params?: {}): Promise<Dict>;
    privatePostTradeVolume (params?: {}): Promise<Dict>;
    privatePostAddExport (params?: {}): Promise<Dict>;
    privatePostExportStatus (params?: {}): Promise<Dict>;
    privatePostRetrieveExport (params?: {}): Promise<Dict>;
    privatePostRemoveExport (params?: {}): Promise<Dict>;
    privatePostGetApiKeyInfo (params?: {}): Promise<Dict>;
    privatePostAddOrder (params?: {}): Promise<Dict>;
    privatePostAmendOrder (params?: {}): Promise<Dict>;
    privatePostCancelOrder (params?: {}): Promise<Dict>;
    privatePostCancelAll (params?: {}): Promise<Dict>;
    privatePostCancelAllOrdersAfter (params?: {}): Promise<Dict>;
    privatePostGetWebSocketsToken (params?: {}): Promise<Dict>;
    privatePostAddOrderBatch (params?: {}): Promise<Dict>;
    privatePostCancelOrderBatch (params?: {}): Promise<Dict>;
    privatePostEditOrder (params?: {}): Promise<Dict>;
    privatePostDepositMethods (params?: {}): Promise<Dict>;
    privatePostDepositAddresses (params?: {}): Promise<Dict>;
    privatePostDepositStatus (params?: {}): Promise<Dict>;
    privatePostWithdrawMethods (params?: {}): Promise<Dict>;
    privatePostWithdrawAddresses (params?: {}): Promise<Dict>;
    privatePostWithdrawInfo (params?: {}): Promise<Dict>;
    privatePostWithdraw (params?: {}): Promise<Dict>;
    privatePostWithdrawStatus (params?: {}): Promise<Dict>;
    privatePostWithdrawCancel (params?: {}): Promise<Dict>;
    privatePostWalletTransfer (params?: {}): Promise<Dict>;
    privatePostCreateSubaccount (params?: {}): Promise<Dict>;
    privatePostAccountTransfer (params?: {}): Promise<Dict>;
    privatePostEarnAllocate (params?: {}): Promise<Dict>;
    privatePostEarnDeallocate (params?: {}): Promise<Dict>;
    privatePostEarnAllocateStatus (params?: {}): Promise<Dict>;
    privatePostEarnDeallocateStatus (params?: {}): Promise<Dict>;
    privatePostEarnStrategies (params?: {}): Promise<Dict>;
    privatePostEarnAllocations (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
